export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10595.cfb46d74.jpg";